import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./login.css";
import axios from "axios";
import { URL } from "../AxiosUrlGlobal";
import ReactPixel from "react-facebook-pixel";

function Login() {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const initialTab = queryParams.get("tab") || "login";

  const [signup, setSignup] = useState(initialTab === "signup");
  const [login, setLogin] = useState(initialTab === "login");

  const [SignupLoading, setSignupLoading] = useState(false);
  const [user_id, setUserID] = useState(null);

  const [LoginLoading, setLoginLoading] = useState(false);
  const [lMobile, setLMobile] = useState("");
  const [lpass, setLpass] = useState("");

  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUserName] = useState("");

  const handleTabChange = (tab) => {
    if (tab === "login") {
      setSignup(false);
      setLogin(true);
      navigate("?tab=login");
    } else if (tab === "signup") {
      setSignup(true);
      setLogin(false);
      navigate("?tab=signup");
    }
  };

  const handleLogin = async () => {
    if (!lMobile || !lpass) {
      toast.error("Mobile number and password are required");
      return;
    }
    
    setLoginLoading(true);
    axios
      .post(`${URL}/login-admin`, { lMobile, lpass })
      .then((res) => {
        console.log(res.data);
        setLoginLoading(false);
        if (res.data.message === "Password not match") {
          toast.error("Password not match");
        } else if (res.data.message === "User not found") {
          toast.error("User not found..");
        } else if (res.data.refreshToken) {
          localStorage.setItem("token", res.data.refreshToken);
          localStorage.setItem("id", res.data.UserId);
          localStorage.setItem("IsAdmin", res.data.IsAdmin);
          localStorage.setItem("AdminType", res.data.AdminType);

          if (res.data.IsAdmin && res.data.AdminType === "Supper") {
            window.location.reload("/dashboard");
          } else if (res.data.IsAdmin && res.data.AdminType === "Admin") {
            window.location.reload("/dashboard");
          } else if (res.data.IsAdmin && res.data.AdminType === "Team") {
            window.location.reload("/users");
          } else if (res.data.IsAdmin && res.data.AdminType === "CallCenter") {
            window.location.reload("/users");
          }
        }
      })
      .catch((err) => {
        setLoginLoading(false);
        toast.error(err.response.data);
      });
  };

  const handleSignup = async () => {
    if (!mobile || !password || !username) {
      toast.error("Mobile, username, and password are required.");
      return;
    }
    if (mobile.length !== 11) {
      toast.error("১১ সংখ্যার মোবাইল নম্বর লিখুন");
      return;
    }
    
    setSignupLoading(true);
    axios
      .post(`${URL}/signup-admin`, { mobile, password, username })
      .then((res) => {
        setSignupLoading(false);
        if (res.data === "User already exists") {
          toast.error("User already exists");
        } else if (res.data.refreshToken) {
          toast.success("SignUp complete - Please LogIn");
          handleTabChange("login");
        }
      })
      .catch((err) => {
        setSignupLoading(false);
        toast.error(err.response.data);
      });
  };

  const handleKeyPress = (event, action) => {
    if (event.key === 'Enter') {
      action();
    }
  };

  useEffect(() => {
    let is_running = false;

    if (is_running === true) {
      return;
    }

    is_running = true;
    const options = {
      autoConfig: true,
      debug: false,
    };
    ReactPixel.init("6874141362695006", options);
    ReactPixel.pageView();
    is_running = false;
  }, []);

  return (
    <div className="login-container">
      <ToastContainer position="top-center" />
      
      <div className="login-wrapper">
        <div className="login-card">
          <div className="login-header">
            <img
              src="/logo.png"
              alt="Bibaho Bangla"
              className="login-logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://placehold.co/200x60/FE444D/white?text=বিবাহ+বাংলা";
              }}
            />
            <h1>Admin Panel</h1>
          </div>

          <div className="login-tabs">
            <button 
              className={login ? "tab-active" : "tab"} 
              onClick={() => handleTabChange("login")}
            >
              Sign In
            </button>
            <button 
              className={signup ? "tab-active" : "tab"} 
              onClick={() => handleTabChange("signup")}
            >
              Sign Up
            </button>
          </div>

          <div className="login-form-container">
            {login && (
              <div className="login-form">
                <div className="form-group">
                  <label htmlFor="mobile">Mobile Number</label>
                  <div className="input-with-icon">
                    <span className="material-icons input-icon">phone</span>
                    <input
                      id="mobile"
                      type="number"
                      placeholder="Enter your mobile number"
                      onChange={(e) => setLMobile(e.target.value)}
                      value={lMobile}
                      onKeyPress={(e) => handleKeyPress(e, handleLogin)}
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <div className="input-with-icon">
                    <span className="material-icons input-icon">lock</span>
                    <input
                      id="password"
                      type="password"
                      placeholder="Enter your password"
                      onChange={(e) => setLpass(e.target.value)}
                      value={lpass}
                      onKeyPress={(e) => handleKeyPress(e, handleLogin)}
                    />
                  </div>
                </div>
                
                <button 
                  className="submit-btn" 
                  onClick={handleLogin}
                  disabled={LoginLoading}
                >
                  {LoginLoading ? (
                    <span className="loading-spinner"></span>
                  ) : (
                    <>
                      <span className="material-icons btn-icon">login</span>
                      Sign In
                    </>
                  )}
                </button>
                
                <div className="forgot-password">
                  <span onClick={() => navigate("/forgot-password")}>
                    Forgot Password?
                  </span>
                </div>
              </div>
            )}
            
            {signup && (
              <div className="signup-form">
                <div className="form-group">
                  <label htmlFor="username">Full Name</label>
                  <div className="input-with-icon">
                    <span className="material-icons input-icon">person</span>
                    <input
                      id="username"
                      type="text"
                      placeholder="Enter your full name"
                      onChange={(e) => setUserName(e.target.value)}
                      value={username}
                      onKeyPress={(e) => handleKeyPress(e, handleSignup)}
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="signup-mobile">Mobile Number</label>
                  <div className="input-with-icon">
                    <span className="material-icons input-icon">phone</span>
                    <input
                      id="signup-mobile"
                      type="number"
                      placeholder="Enter your mobile number"
                      onChange={(e) => setMobile(e.target.value)}
                      value={mobile}
                      onKeyPress={(e) => handleKeyPress(e, handleSignup)}
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="signup-password">Password</label>
                  <div className="input-with-icon">
                    <span className="material-icons input-icon">lock</span>
                    <input
                      id="signup-password"
                      type="password"
                      placeholder="Create a password"
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                      onKeyPress={(e) => handleKeyPress(e, handleSignup)}
                    />
                  </div>
                </div>
                
                <button 
                  className="submit-btn" 
                  onClick={handleSignup}
                  disabled={SignupLoading}
                >
                  {SignupLoading ? (
                    <span className="loading-spinner"></span>
                  ) : (
                    <>
                      <span className="material-icons btn-icon">person_add</span>
                      Create Account
                    </>
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      
      <div className="login-footer">
        <p>&copy; {new Date().getFullYear()} Bibaho Bangla. All rights reserved.</p>
      </div>
    </div>
  );
}

export default Login;
